import { render, staticRenderFns } from "./StContainerCta.vue?vue&type=template&id=14b8774e&scoped=true"
import script from "./StContainerCta.vue?vue&type=script&lang=ts"
export * from "./StContainerCta.vue?vue&type=script&lang=ts"
import style0 from "./StContainerCta.vue?vue&type=style&index=0&id=14b8774e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b8774e",
  null
  
)

export default component.exports